/**
 * Message to send to the user when an app was updated.
 *
 * @export
 * @param {string} appId
 * @returns
 */
export function appSuccessfullyUpdated(appId: string) {
    return `${appId} updated successfully`;
}

/**
 * Message to send to the user when a channel was updated.
 *
 * @export
 * @param {string} channelId
 * @returns
 */
export function channelSuccessfullyUpdated(channelId: string) {
    return `${channelId} updated successfully`;
}

/**
 * Message to send to the user when a channel was deleted.
 *
 * @export
 * @returns
 */
export function channelSuccessfullyDeleted() {
    return `Channel deleted successfully`;
}

/**
 * Message to send to the user when a channel credentials were uploaded.
 *
 * @export
 * @returns
 */
export function credentialsSuccessfullyUploaded() {
    return `Credentials uploaded successfully`;
}